module.exports = __webpack_public_path__ + "img/个人用户名.b3f28650.svg";